import HOME_ICON from "@/assets/icons/home.svg";
import CHEVRON_RIGHT_GRAY from "@/assets/icons/chevron-right-gray.svg";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import "./style.scss";

const Breadcrumb = () => {
  const location = useLocation();

  const routePath = useMemo(() => {
    const { pathname } = location;

    const breakPath = pathname.split("/");
    const result: string[] = [];

    breakPath.forEach((path: string) => {
      if (path) {
        result.push("separator");
        if (path.includes("-")) {
          result.push(path.split("-").join(" "));
        } else {
          result.push(path);
        }
      }
    });

    return result;
  }, [location]);

  const isShow = useMemo(() => {
    const { pathname } = location;
    return pathname === "/dashboard" ? false : true;
  }, [location]);

  return (
    <>
      {isShow && (
        <div className="breadcrumb-component-wrapper">
          <img src={HOME_ICON} alt="home-icon" />
          {routePath.map((path, index) => (
            <span key={index}>
              {path === "separator" && (
                <img src={CHEVRON_RIGHT_GRAY} alt="breadcrum-separator" />
              )}
              {path !== "separator" && index !== routePath.length - 1 && (
                <label className="menu-label">{path}</label>
              )}
              {path !== "separator" && index === routePath.length - 1 && (
                <label className="menu-end">{path}</label>
              )}
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default Breadcrumb;
